import 'css-chunksrc/client/pages/utilityPage/projectModelsPage/loader/projectModel/styles.scss';export default {
  "projectModel": "_projectModel_kqbqy_1",
  "name": "_name_kqbqy_14",
  "description": "_description_kqbqy_18",
  "line": "_line_kqbqy_22",
  "buttons": "_buttons_kqbqy_26",
  "edit": "_edit_kqbqy_38",
  "button": "_button_kqbqy_26"
};